// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8b0809fd","977":"6a90e0bb"}[chunkId] + ".chunk.js";
};